import Pin from "./Pin";
// import Form from "react-bootstrap/Form";
import TimeField from "../libs/timeField";
import { getArrivalTimeAsDayjs, getDepartureTimeAsDayjs, getDistanceInMetres, getStartDepotDepartureTime, getEndDepotArrivalTime, formatDateTime } from "../libs/routes-lib";
import dayjs from "../dayjs";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useScroll } from "../libs/hooksLib";
import { Form, Button, Col, Flex, Popover, Row, Tooltip, Card, Space, DatePicker, TimePicker, Switch, Select, Input } from "antd";
import { useAppContext } from "../libs/contextLib";
import { noop } from "lodash/util";
import { dayjsToSecsSinceMidnight, secsSinceMidnightToDayjs } from "../model/timeFilter";
import RouteNumber from "./RouteNumber";
import { find } from "lodash/collection";
import { uniq } from "lodash/array";
import { EyeOutlined, DragOutlined, PlusOutlined } from "@ant-design/icons";
import { ReactComponent as Trash } from '../assets/icons/Trash.svg';
import { values } from "lodash/object";
import LoadMessage from './LoadMessage';
import { DndContext, closestCenter, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { arrayMove, SortableContext, useSortable, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import LocationLookup from './LocationLookup';
import { ulid } from "ulid";
import { stopModelData } from "../services/ModelService";
import { ReactComponent as Oneway } from '../assets/icons/Oneway.svg';
import { ReactComponent as Return } from '../assets/icons/Return.svg';
import { ReactComponent as Warning } from '../assets/icons/Warning.svg';
import { ReactComponent as Time } from '../assets/icons/Time.svg';
import { clone, first, last } from "lodash";
import DisplayStop from "./DisplayStop";
import useAllStops from "../hooks/useAllStops";
import { getCachedPathDebounced } from "../libs/pathLib";
import { BusRoute, DATE_STRING } from "../model/busRoute";
import { Bus } from "./Icons";
import useAllVehicleTypes from "../hooks/useAllVehicleType";
import { dA } from "@fullcalendar/core/internal-common";

function StopTime({
    route, charter,
    idx,
    trip,
    stopValidationMessages,
    arriveValidationMessages,
    departValidationMessages,
    isAdmin,
    immutable,
    setEditing,
    editing,
    setFocusStop,
    setSelectedStop,
    selectedStop,
    scrollRef,
    executeScroll,
    setUpdated,
    stop,
    previousStop,
    previousStopTime,
    allStops,
    operator,
    showSeconds,
    cumulativeUpdate,
    focus,
    setFocus,
    focusTransfers,
    setFocusTransfers = noop,
    setAllStops,
    handleAddStopTime,
    setRoute,
    setRouteNow,
    stopTimes,
    viewOnly = false,
    calculateArrivalTime
}) {

    const { setChatContext, setChatOpen } = useAppContext();
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({
        id: stop?.stopTimeId,
        data: {
            type: 'stop',
            stop
        }
    });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };

    // Add missing variables
    const isFirst = idx === 0;
    const isLast = idx === stopTimes.length - 1;
    const returnEnabled = route?.returnEnabled && stopTimes.filter(s => s.stopId).length > 1;
    const index = idx + 1; // 1-based index for display

    const setTrip = useCallback((trip, now) => {
        route = route.clone();
        const tripIdx = route.services.findIndex(t => t.tripId === trip.tripId);
        route.services[tripIdx] = trip;
        route = new BusRoute(route);
        route.updateStops();

        if(now) {
            setRouteNow(route);
        } else {
            setRoute(route);
        }
    }, [setRoute, setRouteNow, allStops, route]);

    // Add back the onChange function
    const onChange = (changes) => {
        if(changes.date) {
            if(idx === 0) trip.date = changes.date;
            else trip.dates[idx] = changes.date;
            setTrip(trip, true);
            setUpdated(true);
        } else {
            const newStopTimes = [...stopTimes];

            const stopTimeChanges = {
                arriveSecs: changes.arriveSecs,
                departSecs: changes.departSecs,
                stopId: changes.stopId,
                stopTimeId: changes.stopTimeId,
            }

            // Update the stop in the trip's stopTimes array
            newStopTimes[idx] = {
                ...newStopTimes[idx],
                ...stopTimeChanges
            };
            trip.stopTimes = newStopTimes;
            setTrip(trip, true);
            setUpdated(true);
        }
    };

    const onDelete = useCallback(() => {
        // Don't allow deleting if there's only one stop left
        if (stopTimes.length === 0) {
            return;
        }
        const asyncFn = async () => {
            if (idx === stopTimes.length - 1) {
                //trim the route, then append the new stop location
                if(stopTimes.length > 0) {
                    const prevStop = stopTimes[idx - 1];
                    await route.trim(prevStop, true);
                } else {
                    await route.removeStop(stop);
                    route.waypoints.length = 0;
                }
            } else if (idx > 0) {

                // then insert the new stop between the previous and next stop
                const prevStop = stopTimes[idx - 1];
                const nextStop = stopTimes[idx + 1];
                const oldDuration = nextStop.arriveSecs - prevStop.departSecs;

                // if the stop is in the middle somewhere, remove the stop
                await route.removeStop(stop);

                // insert the new waypoints between the previous and next stop
                const {duration} = await route.insertWaypointsBetweenStops(prevStop, nextStop, true);
                const durationDiff = duration - oldDuration;
                // Update arrival and departure times for all stops after prevStop
                for (let i = idx; i < stopTimes.length; i++) {
                    route.stops[i].arriveSecs += durationDiff;
                    route.stops[i].departSecs += durationDiff;
                    route.stopTimes[i].arriveSecs += durationDiff;
                    route.stopTimes[i].departSecs += durationDiff;
                    route.services.forEach(trip => {
                        trip.stops[i].arriveSecs += durationDiff;
                        trip.stops[i].departSecs += durationDiff;
                        trip.stopTimes[i].arriveSecs += durationDiff;
                        trip.stopTimes[i].departSecs += durationDiff;
                    });
                }
            } else {
                // if the stop is the first stop, trim the route from the next stop, then prepend the new stop location
                const nextStop = stopTimes[idx + 1];
                await route.trim(nextStop);

                if (route.returnEnabled && stopTimes.filter(s => s.stopId).length > 2) {
                    // if the first stop is being deleted, trim the route from the second last stop, then add the return stop again
                    const prevStop = stopTimes[stopTimes.length - 2];
                    await route.trim(prevStop, true);
                    await route.appendStop({...stopTimes[0], stopTimeId: ulid(), arriveSecs: 0, departSecs: 0});
                }
            }

            // if (route.returnEnabled && idx > 0) {
            //     if (stopTimes.filter(s => s.stopId).length < 3) {
            //         // if any stop was deleted, trim the route from the second stop, then append the first stop
            //         const prevStop = stopTimes[stopTimes.findIndex(s => s.stopId)];
            //         await route.trim(prevStop, true);
            //     }
            // }

            if(route.stopTimes.length === 0) {
                route.addStopAtIndex( {
                    stopTimeId: ulid(),
                    arriveSecs: 0,
                    departSecs: 0,
                    placeholder: true
                }, idx);
            }
            
            // if this is a return trip and there are only two stops, update the last stop to match the first stop
            route.calculateStartEnd({stops: stopTimes, firstStop: stopTimes[0], lastStop: stopTimes[stopTimes.length - 1], trim: true});

            setRouteNow(route.clone());
            setUpdated(true);
        }
        asyncFn();
    }, [route, stopTimes, idx, stop]);

    const handleClick = (e) => {
        // Only handle click if not dragging
        if (!transform) {
            e.stopPropagation();
            const stopWithDetails = { ...stop, ...allStops[stop?.stopId] };
            setSelectedStop(stopWithDetails);
            if (executeScroll) {
                executeScroll(stopWithDetails);
            }
        }
    };

    const handleDepartDateChange = (value) => {
        if (!stop || !value) return;

        const selectedDate = dayjs(value).startOf('day');
        if(idx === 0) {
            trip.date = selectedDate;
        }
        const baseDate = trip.getDepartureTimeAsDayjs(stop).clone().startOf('day');
        let daysDiff = selectedDate.diff(baseDate, 'days');
        
        if (daysDiff !== 0 && cumulativeUpdate) {
            const updatedStopTimes = [...stopTimes];
            
            // Update current stop
            const currentStop = updatedStopTimes[idx];
            const diff = daysDiff * 24 * 60 * 60
            currentStop.departSecs += diff;

            // Update subsequent stops
            for (let i = idx + 1; i < updatedStopTimes.length; i++) {
                const stop = updatedStopTimes[i];
                stop.arriveSecs += diff;
                stop.departSecs += diff;
            }

            trip.stopTimes = updatedStopTimes;
            setTrip(trip, true);
            setUpdated(true);
        } else {
            // Update only the current stop
            const changes = {
                date: selectedDate
            };
            onChange(changes);
        }
    };

    const handleDepartTimeChange = (e, time) => {
        if (!time) return;
        const value = dayjs(time, 'HH:mm');
        if (!value.isValid()) return;

        // Get the current stop's departure time relative to the trip's date
        const currentDepartTime = trip.getDepartureTimeAsDayjs(stop);
        const currentRelativeDepartSecs = dayjsToSecsSinceMidnight(currentDepartTime);
        
        // Convert the input time to seconds since midnight
        const newRelativeDepartSecs = dayjsToSecsSinceMidnight(value);
        
        // Calculate the time difference in seconds
        const timeDiff = newRelativeDepartSecs - currentRelativeDepartSecs;
        
        // Create a changes object with the new departure time
        const changes = {
            arriveSecs: idx === 0 ? stop.arriveSecs + timeDiff : stop.arriveSecs,
            departSecs: stop.departSecs + timeDiff
        };

        // If cumulative update is enabled, update subsequent stops
        if (cumulativeUpdate) {
            const updatedStopTimes = [...stopTimes];

            // Update the current stop's times
            updatedStopTimes[idx] = {
                ...updatedStopTimes[idx],
                ...changes
            };

            // Update subsequent stops by adding the time difference
            for (let i = idx + 1; i < updatedStopTimes.length; i++) {
                updatedStopTimes[i] = {
                    ...updatedStopTimes[i],
                    arriveSecs: updatedStopTimes[i].arriveSecs + timeDiff,
                    departSecs: updatedStopTimes[i].departSecs + timeDiff
                };
            }

            trip.stopTimes = updatedStopTimes;
            setTrip(trip, true);
            setUpdated(true);
        } else {
            // Use the onChange function to update the stop
            onChange(changes);
        }
    };

    // Add function to handle location changes
    const handleLocationChange = useCallback((value, option) => {
        if (!value || !option) {
            console.warn('Invalid location data received');
            return;
        }

        const processLocationChange = async () => {
            try {
                const location = createLocationObject(option, value);
                await ensureStopHasId(location);

                if (!stop) {
                    return;
                }

                const isPlaceholder = stop.placeholder;
                const isChangingExistingStop = stop.stopId !== location.stopId;

                if (isPlaceholder) {
                    await replacePlaceholder(stop, location);
                } else if (isChangingExistingStop) {
                    await handleStopReplacement(location);
                }

                // Finalize route changes
                route.calculateStartEnd({stops: route.stops, firstStop: route.stops[0], lastStop: route.stops[route.stops.length - 1]});
                setRouteNow(route.clone());
            } catch (error) {
                console.error('Error handling location change:', error);
            }
        };

        const createLocationObject = (option, value) => {
            const {lon, lat, stopName, stopId, place_id} = option;
            return {
                location: value,
                center: [lon, lat],
                stopType: 'charter',
                value,
                lat,
                lon,
                stopName,
                stopId,
                place_id,
            };
        };

        const ensureStopHasId = async (location) => {
            if (!location.stopId) {
                const existingStop = find(values(allStops), {place_id: location.place_id});
                if (existingStop) {
                    Object.assign(location, existingStop);
                    return;
                }
                location.duplicate = -1;
                location.verified = 1;
                const {stopId} = await stopModelData.save(location);
                location.stopId = stopId;
            }
        };

        const replacePlaceholder = async (placeholder, newLocation) => {
            const isPlaceholdersOnly = stopTimes.length === 1;
            const isMiddleStop = !isPlaceholdersOnly && idx > 0 && idx < stopTimes.length - 1;

            if(isPlaceholdersOnly) {
                await route.removeStopAtIndex(idx);
                await route.addStopAtIndex(newLocation, 1);
                route.waypoints = [{lat: newLocation.lat, lon: newLocation.lon, delta: 0, distance: 0, stopId: newLocation.stopId}];
            } else if (isMiddleStop) {
                const prevStop = stopTimes[idx - 1];
                const nextStop = stopTimes[idx + 1];
                await route.removeStopAtIndex(idx);
                if(prevStop && nextStop) {
                    await route.insertStopBetweenStops(newLocation, prevStop, nextStop);
                }
            } else {
                await route.removeStopAtIndex(idx);
                await route.appendStop(newLocation);
            }

            // if this is a return trip and there are only two stops, update the last stop to match the first stop
           if(route.returnEnabled && route.stopTimes.filter(s => s.stopId).length === 2) {
                await route.appendStop({...stopTimes[0], stopTimeId: ulid()});
            }
        };

        const handleStopReplacement = async (location) => {
            const isLastStop = idx === stopTimes.length - 1;
            const isReturnTrip = route.returnEnabled;

            if (isLastStop) {
                await replaceLastStop(location);
            } else if (idx > 0) {
                await replaceMiddleStop(location);
            } else {
                await replaceFirstStop(location);

                // If this is a return trip and first stop was changed, update the last stop too
                if (isReturnTrip && trip.stopTimes.filter(s => s.stopId).length > 1) {
                    await updateLastStopToMatchFirst(location);
                }
            }
        };

        const replaceLastStop = async (location) => {
            const prevStop = stopTimes[idx - 1];
            await route.trim(prevStop, true);
            await route.appendStop(location);
        };

        const replaceMiddleStop = async (location) => {
            const prevStop = stopTimes[idx - 1];
            const nextStop = stopTimes[idx + 1];
            await route.removeStopAtIndex(idx);
            if(prevStop && nextStop) {
                await route.insertStopBetweenStops(location, prevStop, nextStop);
            }
        };

        const replaceFirstStop = async (location) => {
            const nextStop = stopTimes[idx + 1];
            await route.trim(nextStop);
            await route.prependStop(location);
        };

        const updateLastStopToMatchFirst = async (location) => {
            const lastStop = stopTimes[stopTimes.length - 1];
            if (lastStop) {
                const prevStop = stopTimes[stopTimes.length - 2];
                await route.trim(prevStop, true);
                await route.appendStop({...location, stopTimeId: ulid()});
            }
        };

        processLocationChange();
    }, [route, stopTimes, stop, idx, setRouteNow, allStops, returnEnabled]);

    // Add function to handle adding a new stop
    const handleAddStop = async () => {
        try {
            // Create a new stop object with default values
            handleAddStopTime(idx + 1);
        } catch (error) {
            console.error('Error adding new stop:', error);
        }
    };

    const arrivalTime = useMemo(() => {
        if (trip && stop) {
            if(idx > 0) {
                const arrivalDate = trip.getArrivalTimeAsDayjs(stop);
                const previousDepartDate = trip.getDepartureTimeAsDayjs(trip.stopTimes[idx - 1]);
                const diffDays = arrivalDate.clone().startOf('day').diff(previousDepartDate.clone().startOf('day'), 'days');
                return `${diffDays !== 0 ? `(${diffDays > 0 ? '+' : ''}${diffDays}) ` : ''}${arrivalDate.format('h:mm A')}`;
            }
        }
    }, [trip, stop]);

    const showAddStop = useMemo(() => {
        return stopTimes.filter(s => !s.stopId).length === 0 && isLast;
    }, [stopTimes, isLast]);

    return (
        <>
            <div
                ref={setNodeRef}
                style={style}
                className={'stop-item'}
                onMouseOver={() => {
                    if (!editing) {
                        setFocusStop({ ...stop, ...allStops[stop?.stopId] });
                    }
                }}
            >
                <Card
                    size="small"
                    className="stop-card"
                    key={`StopTime-Row-${stop?.stopTimeId}`}
                    title={
                        <div className="stop-header" onClick={handleClick}>
                            <div className='d-flex align-items-center'>
                                {!immutable && !viewOnly && (
                                    <div
                                        className="drag-handle mr-2"
                                        {...attributes}
                                        {...listeners}
                                    >
                                        <DragOutlined />
                                    </div>
                                )}
                                <div className="d-flex align-items-center">
                                    {isFirst ? (
                                        <div className="mr-2">
                                            <Pin size={24} type="bus" sequence="1" />
                                        </div>
                                    ) : isLast && !returnEnabled ? (
                                        <div className="mr-2">
                                            <Pin size={24} type="bus" sequence={index} />
                                        </div>
                                    ) : (
                                        <div className="mr-2">
                                            <Pin size={24} type="bus" sequence={index} />
                                        </div>
                                    )}
                                    <span>
                                        {isFirst ? 'Initial Pickup' :
                                        isLast && returnEnabled ? 'Return' :
                                        isLast && !returnEnabled ? 'Final Drop-off' :
                                            `Stop ${index}`}
                                    </span>
                                </div>
                                {stopValidationMessages?.length > 0 && !stop.placeholder && (
                                    <Tooltip
                                        title={
                                            <div>
                                                {stopValidationMessages.map((m, i) => (
                                                    <p key={`vl_${i}`}>{m.msg}</p>
                                                ))}
                                            </div>
                                        }
                                    >
                                        <span className="validation-icon ml-2"><Warning style={{ height: 14 }} /></span>
                                    </Tooltip>
                                )}
                            </div>
                        </div>
                    }
                    {...viewOnly || trip.stops.length < 2 ? {
                        extra: <></>
                    } : {
                        extra:
                            // Show delete button for all stops except when there's only one stop
                            <Button className='py-0'
                                type="text"
                                icon={<Trash style={{ height: 14 }} />}
                                onClick={() => onDelete(idx)}
                                style={{ height: 24, width: 24 }}
                            />
                    }}
                >
                    <Space direction="vertical" style={{ width: '100%', gap: 4 }}>
                        {viewOnly ?
                            <div className='text-muted font-weight-normal'>
                                {allStops[stop?.stopId]?.stopName || stop?.stopName || stop?.location}
                            </div>
                            :
                            <Form.Item label={isFirst ? 'Pickup Location' : isLast ? 'Drop-off Location' : 'Stop Location'}>
                                <LocationLookup
                                    onClick={() => {
                                        console.log('clicked');
                                    }}
                                    location={{ value: stop?.location || stop?.stopName || stop?.stopId, label: stop?.stopId ? <DisplayStop stop={stop} noWarning={true} noCode={true} noRoutes={true} noInterchange={true} /> : stop?.location }}
                                    setLocation={handleLocationChange}
                                    placeholder="Enter location"
                                    style={{ width: '100%' }}
                                    defaultValue={stop?.location || allStops[stop?.stopId]?.stopName}
                                    allStops={allStops}
                                />
                            </Form.Item>
                        }
                        {!viewOnly &&
                            <Row gutter={8}>
                                <Col span={12}>
                                    <Form.Item label={isFirst ? 'Pickup Date' : 'Depart Date'}>
                                        <div className="time-field-container">
                                            <DatePicker
                                                style={{ width: '100%' }}
                                                disabled={stop.placeholder}
                                                value={trip.getDepartureTimeAsDayjs(stop)}
                                                format="DD/MM/YYYY"
                                                onChange={handleDepartDateChange}
                                                status={arriveValidationMessages?.length && !stop.placeholder  ? 'error' : ''}
                                                minDate={!isFirst ? trip.getDepartureTimeAsDayjs(trip.stopTimes[idx - 1]) : undefined}
                                            />
                                            {arriveValidationMessages?.length > 0 && !stop.placeholder && (
                                                <Tooltip
                                                    title={
                                                        <div>
                                                            {arriveValidationMessages.map((m, i) => (
                                                                <p key={`arr_${i}`}>{m.msg}</p>
                                                            ))}
                                                        </div>
                                                    }
                                                >
                                                    <span className="validation-icon ml-2"><Warning style={{ height: 14 }} /></span>
                                                </Tooltip>
                                            )}
                                        </div>
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label={isFirst ? 'Pickup Time' : 'Depart Time'}>
                                        <div className="time-field-container">
                                            <TimeField
                                                disabled={stop.placeholder}
                                                className={`ant-input ant-input-sm inputtext-small text-center`}
                                                style={{ width: '100%', paddingRight: '30px' }}
                                                value={trip.getDepartureTimeAsDayjs(stop)?.format?.('HH:mm')}
                                                format="HH:mm"
                                                onChange={handleDepartTimeChange}
                                            />
                                            <Time className="time-field-icon" />
                                        </div>
                                        {departValidationMessages?.length > 0 && !stop.placeholder && (
                                            <Tooltip
                                                title={
                                                    <div>
                                                        {departValidationMessages.map((m, i) => (
                                                            <p key={`dep_${i}`}>{m.msg}</p>
                                                        ))}
                                                    </div>
                                                }
                                            >
                                                <span className="validation-icon ml-2"><Warning style={{ height: 14 }} /></span>
                                            </Tooltip>
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>}
                        {arrivalTime && (
                            <div className='text-muted font-weight-normal'>
                                Est. arrival: {arrivalTime}
                            </div>
                        )}
                    </Space>
                </Card>
            </div>
            {showAddStop && <div className='button-separator'>
                <Button type="primary" className="icon-button" icon={<PlusOutlined />} onClick={handleAddStop}>Add Stop</Button>
            </div>}
            {stop?.transfersTo?.length > 0 && (
                <Card size="small" className="transfer-card mt-2">
                    <div className="transfer-header">
                        <EyeOutlined className="mr-2" />
                        <span>Transfers</span>
                    </div>
                    <div className="transfer-routes">
                        {stop?.transfersTo?.map((tx, idx) => (
                            <div
                                key={'tt_' + idx}
                                className={`transfer-route ${tx.invalid ? "transfer-warning" : ""} ${focusTransfers.to.filter(t => t.routeId === tx.routeId).length ? 'Selected' : ''}`}
                                onClick={e => {
                                    if (e.metaKey) return;
                                    e.stopPropagation();
                                    setFocusTransfers(focusTransfers => {
                                        if (find(focusTransfers.to, ['routeId', tx.routeId])) {
                                            focusTransfers.to = focusTransfers.to.filter(t => t.routeId !== tx.routeId);
                                        } else {
                                            focusTransfers.to = focusTransfers.to.concat(tx);
                                        }
                                        return {
                                            ...focusTransfers,
                                            stop: focusTransfers.from?.length || focusTransfers.to?.length ? { ...stop, ...allStops[stop.stopId] } : null
                                        };
                                    });
                                }}
                            >
                                <RouteNumber
                                    key={'TxRidTo' + tx.routeId}
                                    route={tx}
                                    link={true}
                                    meta={true}
                                    tooltip={tx.invalid && tx.warnings?.length ? uniq(tx.warnings).map(w => <p>{w}</p>) : null}
                                />
                            </div>
                        ))}
                    </div>
                </Card>
            )}
            {stop?.transfersFrom?.length > 0 && (
                <Card size="small" className="transfer-card mt-2">
                    <div className="transfer-header">
                        <EyeOutlined className="mr-2" />
                        <span>Pickups</span>
                    </div>
                    <div className="transfer-routes">
                        {stop?.transfersFrom?.map((tx, idx) => (
                            <div
                                key={'tf_' + idx}
                                className={`transfer-route ${tx.invalid ? "transfer-warning" : ""} ${focusTransfers.from.filter(t => t.routeId === tx.routeId).length ? 'Selected' : ''}`}
                                onClick={e => {
                                    if (e.metaKey) return;
                                    e.stopPropagation();
                                    setFocusTransfers(focusTransfers => {
                                        if (find(focusTransfers.from, ['routeId', tx.routeId])) {
                                            focusTransfers.from = focusTransfers.from.filter(t => t.routeId !== tx.routeId);
                                        } else {
                                            focusTransfers.from = focusTransfers.from.concat(tx);
                                        }
                                        return {
                                            ...focusTransfers,
                                            stop: focusTransfers.from?.length || focusTransfers.to?.length ? { ...stop, ...allStops[stop?.stopId] } : null
                                        };
                                    });
                                }}
                            >
                                <RouteNumber
                                    key={'TxRidFrom' + tx.routeId}
                                    route={tx}
                                    link={true}
                                    meta={true}
                                    tooltip={tx.invalid && tx.warnings?.length ? uniq(tx.warnings).map(w => <p>{w}</p>) : null}
                                />
                            </div>
                        ))}
                    </div>
                </Card>
            )}
        </>
    );
}

export default function SimpleStopTimes({
    route, charter,
    allStops,
    showSeconds,
    cumulativeUpdate,
    trip,
    setTrip,
    setRoute,
    setRouteNow,
    showAllStops,
    editingRoute,
    setFocusStop,
    setSelectedStop,
    selectedStop,
    setUpdated = noop,
    immutable = false,
    setFocusTransfers,
    focusTransfers,
    operator, validationHelper = { isValid: true },
    buildToStop,
    showNewStop, setShowNewStop,
    setAllStops,
}) {
    const { isAdmin, messageApi } = useAppContext();
    const [editing, setEditing] = useState(true);
    const [executeScroll, scrollRef] = useScroll();
    const [focus, setFocus] = useState(null);
    const { allDepots } = useAllStops();
    const { allVehicleTypes, allVehicleTypesArray } = useAllVehicleTypes();

    useEffect(() => {
        executeScroll();
    }, [selectedStop, executeScroll]);

    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: {
                distance: 10, // Only activate after dragging 10px
                delay: 250, // Only activate after 250ms
            }
        })
    );

    const handleAddStopTime = useCallback((idx = trip.stops.length-2, placeholder = true) => {
        const newStopTime = {
            stopTimeId: ulid(),
            arriveSecs: isFinite(idx) ? trip.stopTimes[idx - 1]?.arriveSecs || 0 : last(trip.stopTimes)?.arriveSecs || 0,
            departSecs: isFinite(idx) ? trip.stopTimes[idx - 1]?.departSecs || 0 : last(trip.stopTimes)?.departSecs || 0,
            sequence: isFinite(idx) ? idx : 1,
            timingPoint: true,
            placeholder
        };

        route.addStopAtIndex(newStopTime, idx);

        setRouteNow(route.clone());
        setUpdated(true);
    }, [route]);

    useEffect(function ensure1PlaceholderStop() {
        if (!trip) return;

        // If no stops at all, add both placeholder stops at once
        if (!trip.stops?.length) {
            const stop1 = {
                stopTimeId: ulid(),
                arriveSecs: 9 * 3600,
                departSecs: 9 * 3600,
                timingPoint: true,
                placeholder: true
            };

            trip.date = charter.dates?.[0];
            route.addStopAtIndex(stop1, 0);
            setRouteNow(route.clone());
            setUpdated(true);
        }
    }, [trip, setRouteNow, setUpdated]);

    const calculateArrivalTime = async (fromStop, toStop) => {
        if(!fromStop?.lat || !fromStop?.lon || !toStop?.lat || !toStop?.lon) {
            return dayjs();
        }
        const {duration} = await getCachedPathDebounced({profile: 'bus', startCoord: fromStop, endCoord: toStop});
        const fromTime = getDepartureTimeAsDayjs(trip, fromStop);
        if (!fromTime) {
            console.warn('Missing departure time in calculateArrivalTime', { fromStop });
            return dayjs().add(30, 'minute'); // Fallback to current time + 30 minutes
        }
        return fromTime.add(duration, 'seconds');
    };

    const handleDragEnd = useCallback((event) => {
        const { active, over } = event;
        if (active.id !== over?.id) {

            const defaultArriveSecs = trip.stopTimes[0].arriveSecs;
            const defaultDepartSecs = trip.stopTimes[0].departSecs;

            const asyncFn = async () => {

                const movedIndex = trip.stops.findIndex((stop) => stop.stopTimeId === active.id);
                const replacedIndex = trip.stops.findIndex((stop) => stop.stopTimeId === over?.id);
                const replacedStop = trip.stops[replacedIndex];
                const movedStop = trip.stops[movedIndex];

                const prevStopIdx = replacedIndex < movedIndex ? replacedIndex - 1 : movedIndex - 1;
                const nextStopIdx = replacedIndex < movedIndex ? movedIndex + 1 : replacedIndex + 1;

                const replacedDate = replacedStop.date;
                replacedStop.date = movedStop.date;
                movedStop.date = replacedDate;

                // Create a copy of the route to avoid mutating state directly
                const newRoute = route.clone();

                // Moved down the list
                if (replacedIndex < movedIndex) {
                    newRoute.setStopSequence(movedStop, prevStopIdx + 2);
                    newRoute.setStopSequence(replacedStop, nextStopIdx);
                } else {
                    newRoute.setStopSequence(replacedStop, prevStopIdx + 2);
                    newRoute.setStopSequence(movedStop, nextStopIdx);
                }
                await newRoute.rebuildWaypoints({arriveSecs: defaultArriveSecs, departSecs: defaultDepartSecs, date: replacedDate});
                newRoute.calculateStartEnd({stops: newRoute.stops, firstStop: newRoute.stops[0], lastStop: newRoute.stops[newRoute.stops.length - 1], trim: true});

                // Update the route state with a fresh clone
                setRouteNow(newRoute.clone());
                setUpdated(true);
            };
            asyncFn();
        }
    }, [route, trip]);

    const handleStartDepotChange = async (stopId) => {
        const depot = allDepots[stopId];
        let startDepotDistance = 0;
        let startDepotDuration = 0;
        if(depot && trip.stops?.[0]?.stopId) {
          const {distance, duration} = await getCachedPathDebounced({profile: 'bus', startCoord: depot, endCoord: trip.stops[0]}); 
          startDepotDistance = distance;
          startDepotDuration = duration;
        }
        const _clone = route.clone();
        _clone.startDepot = depot;
        _clone.startDepotDistance = startDepotDistance;
        _clone.startDepotDuration = startDepotDuration;
        setRouteNow(_clone);
    };

    const handleEndDepotChange = async (stopId) => {
        const depot = allDepots[stopId];
        let endDepotDistance = 0;
        let endDepotDuration = 0;
        if(depot && last(trip.stops)?.stopId) {
          const {distance, duration} = await getCachedPathDebounced({profile: 'bus', startCoord: last(trip.stops), endCoord: depot}); 
          endDepotDistance = distance;
          endDepotDuration = duration;
        }
        const _clone = route.clone();
        _clone.endDepot = depot;
        _clone.endDepotDistance = endDepotDistance;
        _clone.endDepotDuration = endDepotDuration;
        setRouteNow(_clone);
    };

    const handleReturnChange = async (enabled) => {
        if (enabled === route.returnEnabled) return;

        const firstStop = trip.stops[0];
        const lastStop = trip.stops[trip.stops.length - 1];

        // Return early if we don't have the necessary stops
        if (!firstStop || !lastStop) {
            messageApi.error("Please add at least one stop before enabling return trips")
            console.warn('Missing first or last stop in handleReturnChange', { firstStop, lastStop });
            return;
        }

        const _clone = route.clone();
        _clone.returnEnabled = enabled;

        try {

            // if return enabled add first stop to end
            if (enabled && firstStop.stopId && lastStop.stopId && firstStop.stopId !== lastStop.stopId) {
                const newStop = {
                    ...firstStop,
                    stopTimeId: ulid(),
                }
                delete newStop.arriveSecs;
                delete newStop.departSecs;
                await _clone.appendStop(newStop);
            } else if (lastStop.stopId && firstStop.stopId === lastStop.stopId) {
                const prevStop = trip.stops[trip.stops.length - 2];
                if (prevStop) {
                    // await _clone.removeStop(lastStop);
                    await _clone.trim(prevStop, true);
                }
            }

            _clone.calculateStartEnd({firstStop: _clone.stops[0], lastStop: last(_clone.stops), trim: true});
            setRouteNow(_clone);
        } catch (error) {
            console.error('Error in handleReturnChange:', error);
            // Set route without making changes to stops
            _clone.returnEnabled = enabled;
            setRouteNow(_clone);
        }
    };

    const handleVehicleTypeChange = (selectedVehicleTypeIds) => {
        const updatedTrip = trip.clone();
        if (!updatedTrip.vehicleTypeQuantities) {
            updatedTrip.vehicleTypeQuantities = {};
        }
        const currentQuantities = { ...updatedTrip.vehicleTypeQuantities };
        Object.keys(currentQuantities).forEach(id => {
            if (!selectedVehicleTypeIds.includes(id)) {
                delete currentQuantities[id];
            }
        });

        selectedVehicleTypeIds.forEach(id => {
            if (!currentQuantities[id]) {
                currentQuantities[id] = 1; // Default to 1 vehicle
            }
        });

        updatedTrip.vehicleTypeQuantities = currentQuantities;
        updatedTrip.vehicleTypes = selectedVehicleTypeIds;
        setTrip(updatedTrip);
    };

    const handleVehicleQuantityChange = (vehicleTypeId, quantity) => {
        const updatedTrip = trip.clone();
        if (!updatedTrip.vehicleTypeQuantities) {
            updatedTrip.vehicleTypeQuantities = {};
        }
        updatedTrip.vehicleTypeQuantities[vehicleTypeId] = parseInt(quantity) || 0;

        setTrip(updatedTrip);
    };

    const returnEnabled = route.returnEnabled;

    return allStops ? (
        <div className="SimpleStopTimes h-100">
            <div className="icon-info-text">
                <div className="w-100">
                    <div className="d-flex align-items-center pt-1">
                        <div className="d-flex flex-column" style={{ width: '50%', gap: '4px' }}>
                            <label style={{fontSize: '13px', color: '#838792'}}>Select vehicle type</label>
                            <Select
                                mode="multiple"
                                style={{ width: '100%' }}
                                placeholder="Select vehicle types"
                                value={trip.vehicleTypes || []}
                                onChange={handleVehicleTypeChange}
                                options={allVehicleTypesArray?.map(vehicleType => ({
                                value: vehicleType.vehicleTypeId,
                                label: vehicleType.vehicleTypeName
                                }))}
                                status={!trip.vehicleTypes || trip.vehicleTypes?.length == 0 ? "error" : ""}
                            />
                        </div>
                        {trip.vehicleTypes && trip.vehicleTypes.length > 0 && (
                            <div className="d-flex flex-wrap" style={{ width: '50%', gap: '8px', paddingLeft: '14px' }}>
                            {trip.vehicleTypes.map(id => (
                                <div key={id} style={{ display: 'flex', flexDirection: 'column' }}>
                                    <span style={{ marginRight: '4px', fontSize: '12px' }}>
                                        {allVehicleTypes?.[id]?.vehicleTypeName}:
                                    </span>
                                    <Input
                                        type="number"
                                        min={1}
                                        style={{ width: '42px', padding: '4px 0 4px 8px' }}
                                        value={trip.vehicleTypeQuantities?.[id] || 1}
                                        onChange={(e) => handleVehicleQuantityChange(id, e.target.value)}
                                    />
                                </div>
                            ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <Row gutter={16}>
                <Col span={24} className="pt-2 pb-3">
                    <Form.Item label="Start Depot">
                        <Select
                            placeholder="Select start depot"
                            value={route.startDepot?.stopId}
                            onChange={handleStartDepotChange}
                            options={Object.values(allDepots || {}).map(depot => ({
                                value: depot.stopId,
                                label: depot.stopName
                            }))}
                            style={{ height: '100%' }}
                            allowClear
                        />
                        {route.startDepot && charter && route.startDepotDuration > 0 && (
                            <div className="depot-time-info" style={{ fontSize: '13px', color: '#666', marginTop: '5px' }}>
                                <span style={{ fontWeight: 'bold' }}>Departure:</span> {formatDateTime(getStartDepotDepartureTime(route, trip.stops[0])) || 'Calculating...'}
                            </div>
                        )}
                    </Form.Item>
                </Col>
            </Row>
            <div className='charter-type-button-wrap' style={{ marginBottom: 10 }}>
                <div className={`charter-type-button ${!returnEnabled ? 'active' : ''}`} onClick={() => handleReturnChange(false)}>
                    <Oneway style={{ height: 34 }} />
                    <strong>One Way</strong>
                </div>
                <div className={`charter-type-button ${returnEnabled ? 'active' : ''}`} onClick={() => handleReturnChange(true)}>
                    <Return style={{ height: 30 }} />
                    <strong>Return Trip</strong>
                </div>
            </div>
            <div className="service-rows-wrap stops-container">
                <DndContext
                    sensors={sensors}
                    collisionDetection={closestCenter}
                    onDragEnd={handleDragEnd}
                >
                    <SortableContext items={trip.stops.map(stop => stop.stopTimeId)} strategy={verticalListSortingStrategy}>
                        {
                            trip.stops?.map((stopTime, idx) => {
                                const stopValidationMessages = validationHelper.stops[idx] ? validationHelper.stops[idx].filter(s => !!s && (!s.tripId || (s.stop && s.tripId === trip.tripId))) : []
                                const arriveValidationMessages = validationHelper.stops[idx] ? validationHelper.stops[idx].filter(s => !!s && s.tripId === trip.tripId && s.arrive) : []
                                const departValidationMessages = validationHelper.stops[idx] ? validationHelper.stops[idx].filter(s => !!s && s.tripId === trip.tripId && s.depart) : []
                                return (
                                    <StopTime
                                        route={route} charter={charter}
                                        key={'st-' + idx} idx={idx} showSeconds={showSeconds} isAdmin={isAdmin}
                                        immutable={immutable} focus={focus} setFocus={setFocus}
                                        setEditing={setEditing}
                                        editing={editing} stopValidationMessages={stopValidationMessages}
                                        arriveValidationMessages={arriveValidationMessages}
                                        departValidationMessages={departValidationMessages}
                                        setFocusStop={setFocusStop} setSelectedStop={setSelectedStop}
                                        selectedStop={selectedStop}
                                        scrollRef={scrollRef} executeScroll={executeScroll} setUpdated={setUpdated} stop={stopTime}
                                        previousStop={trip.stops[idx - 1]} previousStopTime={trip.stopTimes[idx - 1]}
                                        trip={trip} cumulativeUpdate={cumulativeUpdate}
                                        allStops={allStops} operator={operator} stopTimes={trip?.stops}
                                        setFocusTransfers={setFocusTransfers} focusTransfers={focusTransfers}
                                        setAllStops={setAllStops} handleAddStopTime={handleAddStopTime}
                                        setRoute={setRoute} setRouteNow={setRouteNow}
                                        calculateArrivalTime={calculateArrivalTime}
                                        viewOnly={idx === trip.stops.length - 1 && trip.stops.filter(s=> s.stopId).length > 1}
                                    />
                                )
                            })
                        }
                    </SortableContext>
                </DndContext>
                {trip.stops.length === 0 && (
                    <div className='button-separator'>
                        <Button type="primary" className="icon-button" icon={<PlusOutlined />} onClick={handleAddStopTime}>Add Stop</Button>
                    </div>)}
                <Row gutter={16} className='mt-3' style={{paddingBottom: '300px'}}>
                    <Col span={24}>
                        <Form.Item label="End Depot">
                            <Select
                                placeholder="Select end depot"
                                value={route.endDepot?.stopId}
                                onChange={handleEndDepotChange}
                                options={Object.values(allDepots || {}).map(depot => ({
                                    value: depot.stopId,
                                    label: depot.stopName
                                }))}
                                style={{ height: '100%' }}
                                allowClear
                            />
                            {route.endDepot && charter && route.endDepotDuration > 0 && (
                                <div className="depot-time-info" style={{ fontSize: '13px', color: '#666', marginTop: '5px' }}>
                                    <span style={{ fontWeight: 'bold' }}>Arrival:</span> {formatDateTime(getEndDepotArrivalTime(route, last(trip.stops))) || 'Calculating...'}
                                </div>
                            )}
                        </Form.Item>
                    </Col>
                </Row>
            </div>
        </div>
    ) : <LoadMessage message={"Loading stops..."} />;
}
